import { keyframes, styled } from "goober";
import type { ComponentProps } from "react";
import {
  activityAnimationPeriod,
  alignToTimeline,
} from "./ActivityAnimationContext";

// Starts the highlight just left of the text so it sweeps in right after the pulsing icon peaks.
const shimmer = keyframes`
  from { background-position: 240px 0; }
  to { background-position: 840px 0; }
`;

// A fixed-width tile keeps the sweep speed the same whatever the text’s length.
// Light mode dims the resting text a step further, since a darker highlight reads far less than a brighter one.
const Shimmer = styled("span")`
  &[data-pending="true"] {
    --shimmer-rest: light-dark(var(--gray-600), var(--text-secondary));
    background: linear-gradient(
      90deg,
      var(--shimmer-rest) 30%,
      var(--text-primary) 50%,
      var(--shimmer-rest) 70%
    );
    background-size: 600px 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shimmer} ${activityAnimationPeriod} linear infinite;
  }
`;

export function ShimmerSpan(props: ComponentProps<typeof Shimmer>) {
  return <Shimmer {...props} onAnimationStart={alignToTimeline} />;
}
